<mat-toolbar class="pl-1">
    <button (click)="toggleSidenav()" class="h-100 sidemenu-toggle px-3">
        <i class="material-icons mt-1">menu</i>
    </button>

    <ng-container *ngIf="navbarTemplate" [ngTemplateOutlet]="navbarTemplate"></ng-container>
</mat-toolbar>